const leaderboard = true
const isLocal = function () {
  return window.nwjs
}
const fullScreenElem = function (doc) {
  if (!doc) {
    doc = document
  }
  return doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement
}
const isIframe = function () {
  const fullScreen = fullScreenElem() || fullScreenElem(parent.document)
  try {
    const differentWindow = (window.self !== window.top)
    return differentWindow && !fullScreen
  } catch (e) {
    return !fullScreen
  }
}
export default {
  isLocal: isLocal,
  fullScreenElem: fullScreenElem,
  isIframe: isIframe,
  offline: isLocal(),
  leaderboard: leaderboard && isLocal()
}
